/*eslint-disable react/no-danger*/
import React, {PropTypes} from 'react';
import {Link} from 'react-router';

import * as pathConstants from '../../constants/pathConstants';
import TextInput from '../common/TextInput';
import SelectInput from '../common/SelectInput';
import NaicsSearchBox from './NAICS/NaicsSearchBox';
import Button from '../common/Button';
import RadioInput from '../common/RadioInput';
import '../../styles/establishment/establishmentForm.css';

const EstablishmentForm = ({
  form,
  establishment,
  onSubmit,
  onCancel,
  submitStatus,
  onChange,
  errors,
  repeatedEstablishment,
  onClick,
  enteringNAICSCode,
  hideNAICSDropDown,
  NAICSOptions,
  onSelectNAICSOptions,
  onBlur,
  onFocus,
  naicsLoading
}) => {
  let totalMsg = '';
  let questions = [];
  let rowQuestions = [];
  const maxLengthForEstablishmentTextInputs = 100;

  if (errors["generalMessage"]) {
    totalMsg = (
      <div className="alert alert-danger">
        <div className="first-line">{errors["generalMessage"]}</div>
      </div>
    );
  }
  if (form.formQuestions) {
    form
      .formQuestions
      .forEach(question => {
        let questionParts = [];
        question
          .questionParts
          .map(questionPart => {
            let type = questionPart.questionPartType;
            if (type === '1') { //multichoice checkbox
            } else if (type === '3') { //radio button
              questionParts.push(
                <div
                  className="question-part"
                  key={questionPart.questionPartName}
                  onFocus={onFocus}>
                  <RadioInput
                    onChange={onClick}
                    label={questionPart.questionPartLabel}
                    name={questionPart.questionPartName}
                    className="establishment-radio-question"
                    fieldClass={questionPart.questionPartName}
                    error={errors[questionPart.questionPartName]}
                    value={establishment[questionPart.questionPartName]}
                    options={questionPart.questionPartOptions}
                    tooltip={questionPart.questionPartTooltipHelp}
                    contextHelp={questionPart.questionPartContextHelp}
                    required={questionPart.questionPartRequired == '1'}
                    onBlur={onBlur}/>
                  {questionPart.questionPartName == "size" && totalMsg}
                </div>
              );
            } else if (type === '4') { //text box
              if (questionPart.questionPartName === 'naics') {
                questionParts.push(<NaicsSearchBox
                  name={questionPart.questionPartName}
                  label={questionPart.questionPartLabel}
                  lookUpNaics={enteringNAICSCode}
                  error={errors[questionPart.questionPartName]}
                  value={establishment[questionPart.questionPartName]}
                  tooltip={questionPart.questionPartTooltipHelp}
                  contextHelp={questionPart.questionPartContextHelp}
                  hideDropDown={hideNAICSDropDown}
                  NAICSOptions={NAICSOptions}
                  naicsLoading={naicsLoading}
                  onSelect={onSelectNAICSOptions}
                  onBlur={onBlur}
                  key="naics-search-box"/>);
              } else {
                let error = errors[questionPart.questionPartName];
                if (repeatedEstablishment &&
                  questionPart.questionPartName === "establishmentName") {
                  let link = (
                    <Link
                      key="repeated-link"
                      to={pathConstants.pathToEstablishmentsDashboardPage
                        + '/' + repeatedEstablishment.id}>
                      View it here.
                    </Link>
                  );
                  error = [
                    errors[questionPart.questionPartName],
                    " ",
                    link
                  ];
                }
                questionParts.push(
                  <div
                    className="question-part"
                    key={questionPart.questionPartName}
                    onFocus={onFocus}>
                    <TextInput
                      type="text"
                      onChange={onChange}
                      placeHolder={questionPart.questionPartLabel}
                      label={questionPart.questionPartLabel}
                      name={questionPart.questionPartName}
                      className="establishment-text-input"
                      fieldClass={questionPart.questionPartName}
                      error={error}
                      value={establishment[questionPart.questionPartName]}
                      tooltip={questionPart.questionPartTooltipHelp}
                      contextHelp={questionPart.questionPartContextHelp}
                      required={questionPart.questionPartRequired == '1'}
                      onBlur={onBlur}
                      maxLength={maxLengthForEstablishmentTextInputs}/>
                  </div>
                );
              }

            } else if (type === '6') { //select box
              questionParts.push(
                <div
                  className="question-part"
                  key={questionPart.questionPartName}
                  onFocus={onFocus}>
                  <SelectInput
                    name={questionPart.questionPartName}
                    label={questionPart.questionPartLabel}
                    onChange={onChange}
                    value={establishment[questionPart.questionPartName]}
                    error={errors[questionPart.questionPartName]}
                    options={questionPart.questionPartOptions}
                    className={"establishment-select-input "
                      + questionPart.questionPartName}
                    fieldClass={questionPart.questionPartName}
                    tooltip={questionPart.questionPartTooltipHelp}
                    contextHelp={questionPart.questionPartContextHelp}
                    required={questionPart.questionPartRequired == '1'}
                    onBlur={onBlur}/>
                </div>
              );
            }
          });
        if (question.questionName === 'zipCode' ||
          question.questionName === 'city' ||
          question.questionName === 'state') {
          rowQuestions.push(
            <div className="question"
              key={question.questionID || question.questionName}>
              {question.questionGroupHelpText && <div
                dangerouslySetInnerHTML={{
                __html: question.questionGroupHelpText
              }}/>}
              {questionParts}
            </div>
          );
          if (rowQuestions.length === 3) {
            questions.push(
              <div className="row zipcode-city-state-group" key="address">
                {rowQuestions}
              </div>
            );
          }
        } else {
          questions.push(
            <div className="question"
              key={question.questionID || question.questionName}>
              {question.questionGroupHelpText && <div
                dangerouslySetInnerHTML={{
                __html: question.questionGroupHelpText
              }}/>}
              {questionParts}
            </div>
          );
        }
      });
  }
  return (
    <div id="establishment-panel" className="panel">
      <div className="panel-heading"/>
      <div
        className="form-instructions"
        dangerouslySetInnerHTML={{
        __html: form.formPageHelp
      }}/>
      <div className="panel-body">
        <div className="required-info">
          <span className="required-asterisk">*</span>
          <strong>
            Required Fields</strong>
        </div>
        <div className="establishment-buttons-container row">
          <form>
            {questions}
            <div className="row">
              <div id="submit-establishment"
                className="col-12">
                <Button
                  className="submit-establishment pull-right"
                  value={"Save"}
                  disabled={!submitStatus}
                  onClick={onSubmit}
                  title="Save Establishment"/>
                <a
                  disabled={false}
                  href="#"
                  title="Cancel creating an Establishment"
                  className="cancel-submit pull-right"
                  onClick={onCancel}>
                  Cancel
                </a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

EstablishmentForm.propTypes = {
  form: PropTypes.object.isRequired,
  removalForm: PropTypes.object,
  establishment: PropTypes.object.isRequired,
  repeatedEstablishment: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  submitStatus: PropTypes.bool.isRequired,
  enteringNAICSCode: PropTypes.func.isRequired,
  hideNAICSDropDown: PropTypes.bool.isRequired,
  onSelectNAICSOptions: PropTypes.func.isRequired,
  naicsLoading: PropTypes.bool.isRequired,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  NAICSOptions: PropTypes.array,
  errors: PropTypes.object
};

export default EstablishmentForm;



/** WEBPACK FOOTER **
 ** ./src/components/establishment/EstablishmentForm.js
 **/